var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagicWand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M462.5 76.2L374.3 164.4L475.6 265.7L563.8 177.5C571.6 169.6 576 159 576 148C576 137 571.6 126.4 563.8 118.5L521.5 76.2C513.6 68.4 503 64 492 64C481 64 470.4 68.4 462.5 76.2zM340.4 198.3L76.2 462.5C68.4 470.4 64 481 64 492C64 503 68.4 513.6 76.2 521.5L118.5 563.8C126.4 571.6 137 576 148 576C159 576 169.6 571.6 177.5 563.8L441.7 299.6L340.4 198.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWand);
export default __webpack_public_path__ + "static/media/magic-wand.55e13d419906623af2dd6fe4391e52eb.svg";
export { ForwardRef as ReactComponent };